module.exports = fs;


/*****************
 ** WEBPACK FOOTER
 ** external "fs"
 ** module id = 677
 ** module chunks = 0
 **/